import React, { createContext, useCallback, useContext, useState, useEffect } from 'react';
import { getToken, setRole } from '../services/auth';
import { voleeApi } from '../api/VoleeApi';

const PermissionContext = createContext();

export function usePermissions() {
    return useContext(PermissionContext);
}

export function PermissionProvider({ children }) {
    const [permissions, setPermissions] = useState([]);
    const [loading, setLoading] = useState(true);

    const refreshPermissions = useCallback(async () => {
        try {
            setLoading(true);
            if (!getToken()) {
                setPermissions([]);
                setRole('');
                return;
            }

            const perms = await voleeApi.permission.my();
            setPermissions(perms || []);
            setRole((perms || []).join(','));
        } catch (error) {
            console.error('Failed to refresh permissions:', error);
            setPermissions([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refreshPermissions();
    }, [refreshPermissions]);

    const hasPermission = (permission) => {
        return permissions.includes(permission);
    };

    const hasAnyPermission = (permissionList) => {
        return permissionList.some(permission => permissions.includes(permission));
    };

    const isAdmin = () => {
        return hasPermission('CAN_VIEW_ADMIN_PANEL');
    };

    const canModerateCommunity = () => {
        return hasPermission('CAN_MODERATE_COMMUNITY');
    };

    return (
        <PermissionContext.Provider value={{
            permissions,
            loading,
            hasPermission,
            hasAnyPermission,
            isAdmin,
            canModerateCommunity,
            refreshPermissions
        }}>
            {children}
        </PermissionContext.Provider>
    );
}
